import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Action } from '../../../../models/core/action';
import { ToolbarButtonComponent } from '../../buttons/toolbar-button.component';
import { MenuComponent } from '../../panels/menu.component';
import { ColumnComponent } from '../../table/column.component';
import { TableComponent } from '../../table/table.component';
import { CorpStruct } from './corp-struct-selector.component';
import { dialogPaginatorDropdownStyles } from '../../table/dialog-paginator-dropdown.styles';

@Component({
  selector: 'app-corp-structs',
  standalone: true,
  host: {
    '[class.dialog-table-paginator-dropdown-self]':
      "paginatorDropdownAppendTo === 'self'",
  },
  imports: [
    TableComponent,
    ColumnComponent,
    ToolbarButtonComponent,
    MenuComponent,
  ],
  template: `
    <app-table
      #table
      [dataSource]="items"
      dataKey="corpStructId"
      [showActions]="showDeleteColumn"
      [showSelection]="true"
      (actionClick)="actionMenu.toggle($event)"
      emptyMessage="Click add corporate structure"
      emptyIcon="fa-light fa-building"
      [paginatorDropdownAppendTo]="paginatorDropdownAppendTo"
      (selectedEvent)="onSelectedChanged($event)"
    >
      <app-column name="code" label="Code" />
      <app-column name="name" label="Name" />
      <app-column name="accountNumber" label="Account Number" />
      <app-column name="unitNumber" label="Unit Number" />
      <app-column name="node" label="Node" />
      @if (showDeleteColumn) {
        <app-column name="action" label="Action">
          <ng-template #value let-row>
            <app-toolbar-button
              type="Compact"
              icon="fa-light fa-trash-can"
              ariaLabel="Delete"
              (click)="deleteRow(row, $event)"
            />
          </ng-template>
        </app-column>
      }
    </app-table>
    <app-menu [items]="actions" #actionMenu (click)="onAction($event)" />
  `,
  styles: dialogPaginatorDropdownStyles,
})
export class CorporateStructureComponent {
  @ViewChild('table')
  table: TableComponent;

  @Input()
  items: CorpStruct[] = [];

  @Input()
  paginatorDropdownAppendTo: 'body' | 'self' = 'body';

  @Input()
  showDeleteColumn = true;

  @Output()
  selected = new EventEmitter<CorpStruct[]>();

  @Output()
  itemsChanged = new EventEmitter<CorpStruct[]>();

  selectedItems: CorpStruct[] = [];

  get selectedCount(): number {
    return this.selectedItems?.length || 0;
  }

  actions: Action[] = [{ label: 'Delete selected' }, { label: 'Delete all' }];

  onSelectedChanged(event: CorpStruct[]) {
    this.selectedItems = event || [];
    this.selected.emit(this.selectedItems);
  }

  onAction(event: Action) {
    if (event.label === 'Delete all') {
      this.items = [];
      this.selectedItems = [];
      this.selected.emit([]);
      this.itemsChanged.emit([]);
    } else if (event.label === 'Delete selected') {
      const selectedIds = new Set(
        this.selectedItems.map((i) => i.corpStructId),
      );
      this.items = this.items.filter((i) => !selectedIds.has(i.corpStructId));
      this.selectedItems = [];
      this.selected.emit([]);
      this.itemsChanged.emit(this.items);
    }
  }

  deleteRow(row: CorpStruct, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.items = this.items.filter((i) => i.corpStructId !== row.corpStructId);
    this.selectedItems = this.selectedItems.filter(
      (i) => i.corpStructId !== row.corpStructId,
    );
    this.selected.emit(this.selectedItems);
    this.itemsChanged.emit(this.items);
  }

  getSelectedItems(): CorpStruct[] {
    return this.selectedItems;
  }

  clearSelection() {
    this.selectedItems = [];
    this.selected.emit([]);
  }
}
